export function firstLetterTolowerCase(str) {
  return str.charAt(0).toLowerCase() + str.slice(1);
}

export function flattenErrorsWithoutRename(errors, category) {
  return errors
    .filter((r) => firstLetterTolowerCase(r.Field.split(".")[0]) === category)
    .reduce((map, obj) => {
      map[obj.Field.split(".")[1]] = obj.Messages[0];
      return map;
    }, {});
}

const escapeMap = {
  "&": "&amps;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#x27;",
  "/": "&#x2F",
};

const htmlEscaper = /[&<>"'`]/g;

export function escape(val) {
  return ("" + val).replace(htmlEscaper, function (match) {
    return escapeMap[match];
  });
}

export function creatBlobFromBase64(content, contentType) {
  // decode base64 string, remove space for IE compatibility
  var binary = atob(content.replace(/\s/g, ""));
  var len = binary.length;
  var buffer = new ArrayBuffer(len);
  var view = new Uint8Array(buffer);
  for (var i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }

  // create the blob object
  return new Blob([view], { type: contentType });
}

export function timeSince(date) {
  var seconds = Math.floor((new Date() - new Date(date)) / 1000);
  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + "y";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + "mo";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + "d";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + "h";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + "min";
  }
  return Math.floor(seconds) + "s";
}
